import BaseModel from '@/models/BaseModel'

export default class OrderProduct extends BaseModel {
  defaults () {
    return {
      uuid: null,
      provider: null,
      status: null,
      amount: 0
    }
  }

  options () {
    return {
      identifier: 'uuid',
      methods: {
        send: 'POST',
        confirm: 'POST',
        bill: 'POST',
        receive: 'POST',
        cancel: 'POST',
        detail: 'GET'
      }
    }
  }

  getDefaultMethods () {
    return {
      fetch: 'GET',
      save: 'POST',
      update: 'PUT',
      create: 'POST',
      patch: 'PUT',
      delete: 'POST'
    }
  }

  send (data) {
    let method = this.getOption('methods.send')
    let route = this.getRoute('send')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers, data }).send()
  }

  confirm (data) {
    let method = this.getOption('methods.confirm')
    let route = this.getRoute('confirm')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers, data }).send()
  }

  bill (data) {
    let method = this.getOption('methods.bill')
    let route = this.getRoute('bill')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers, data }).send()
  }

  receive (data) {
    let method = this.getOption('methods.receive')
    let route = this.getRoute('receive')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers, data }).send()
  }

  cancel (data) {
    let method = this.getOption('methods.cancel')
    let route = this.getRoute('cancel')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers, data }).send()
  }

  detail () {
    let method = this.getOption('methods.detail')
    let route = this.getRoute('detail')
    let params = this.getRouteParameters()
    let headers = this.getDefaultHeaders()
    let url = this.getURL(route, params)

    return this.createRequest({ method, url, headers }).send()
  }

  shouldPatch () {
    return true
  }

  routes () {
    return {
      fetch: `${this.API_BASE}/v1/orders`,
      send: `${this.API_BASE}/v1/orders/{id}/send`,
      confirm: `${this.API_BASE}/v1/orders/{id}/confirm`,
      bill: `${this.API_BASE}/v1/orders/{id}/bill`,
      receive: `${this.API_BASE}/v1/orders/{id}/receive`,
      cancel: `${this.API_BASE}/v1/orders/{id}/cancel`,
      save: `${this.API_BASE}/v1/orders`,
      detail: `${this.API_BASE}/v1/orders/{id}`
    }
  }
}
